export function resolveAuthAppRouterEnabled(rawValue: string | undefined): boolean {
  return rawValue === "1";
}
